<script>
export default {
  methods: {
    emailValid(email) {
      // https://www.w3resource.com/javascript/form/email-validation.php
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    passwordValid(p) {
      const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/ // min. 6 characters, 1 lowercase letter, 1 uppercase letter, 1 number
      return strongPasswordRegex.test(p)
    },
    positiveNumberValid(n) {
      return /^\d+$/.test(n)
    },
    simplePhoneValid(v) {
      return v === '' || (/([(+]*[0-9]+[()+. -]*)/.test(v) && !/[a-zA-Z]/.test(v))
    },
  },
}
</script>
